import CouponBanner from 'common/components/banner/coupon-banner';
import { hasOrderHistory } from 'common/services/user-service';
import { mountBannerComponent } from 'common/util/banner';
import { subscribeToNtf, getEmailSubscriptions } from 'common/services/notification-service';
import { validate } from 'common/util/bc.validation.helper';

function mount(couponData) {
  mountBannerComponent({
    handleSubscribe,
    startChat,
    Component: CouponBanner,
    isAnimated: !has('cleanload'),
    ...couponData,
  });
}

function validateAndSubscribe(email, couponId) {
  return getEmailSubscriptions(email)
    .then((data) => {
      const isNewEmailSub = data && data.subscriptions && data.subscriptions.length === 0;

      if (isNewEmailSub) {
        return subscribeToNtf({ email, couponId });
      } else {
        return new $.Deferred().reject({ reason: 'usedEmail' });
      }
    });
}

function handleSubscribe(opts) {
  const {
    email,
    recaptchaResponse,
    couponId,
    sendCouponByEmail,
  } = opts;
  const isEmailInvalid = validate([{ test: 'email' }], email);

  if (isEmailInvalid) {
    return new $.Deferred().reject({ reason: 'invalidEmail' });
  }

  return hasOrderHistory(email, recaptchaResponse)
    .then((data) => {
      if (data.validRequest) {
        if (data.emailExists) {
          return new $.Deferred().reject({ reason: 'usedEmail' });
        }

        BC.publish('emailCoupon.input', email);

        return sendCouponByEmail ? validateAndSubscribe(email, couponId) : subscribeToNtf({ email, couponId });
      }

      return new $.Deferred().reject({ reason: 'invalidRecaptcha' });
    });
}

function startChat() {
  // ToDo @jdleiva, update selectors on LP
  const $bcChatEl = $(has('large') ? '.js-live-chats' : '.header-livechat__chat-link--mobile').get(0);
  const $ccChatEl = $(has('large') ? '.js-chat-now' : '.gurus-chat-btn').get(0);

  $bcChatEl && $bcChatEl.click();
  $ccChatEl && $ccChatEl.click();
}

export {
  handleSubscribe,
  mount,
  startChat,
};
